module.exports = __webpack_public_path__ + "media/mypage/images/throbber-e2e33e3edaa59d319c38729a86fc1d25.gif";